/*
 * Purpose : App Bar for Header
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from "react";
import {NavLink} from "react-router-dom"
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MoreIcon from "@material-ui/icons/MoreVert";
//import Logo from "./../../../assets/GF_Logo.png";
import Logo from "./../../../assets/GF2.png";
import Logo2 from "./../../../assets/GF.png";
import { Button as ButtonR } from "reactstrap";
import { FaSignOutAlt } from "react-icons/fa";
import HomeNavigation from "./../homeNavigation/homeNavigation";
import HelpIcon from "@material-ui/icons/Help";
// auth config
import { Auth } from "aws-amplify";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
    marginBottom: "25px",
  },
  title: {
    //display: 'none', //to make header disappear in mobile view
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  logo: {
    width: "15%",
    float: "right",
    height: "40%",
    margin: "5px", // till here, mobile view style
    display: "none",
    [theme.breakpoints.up("sm")]: {
      width: "14%",
      float: "right",
      height: "40%",
      marginRight: "15px",
      display: "flex",
    },
  },
  logo2: {
    width: "15%",
    float: "right",
    height: "40%",
    margin: "5px", // till here, mobile view style
    [theme.breakpoints.up("sm")]: {
      width: "14%",
      float: "right",
      height: "40%",
      marginRight: "15px",
      display: "none"
    },
  },
  gflogo: {
    width: "50%",
    float: "right",
    height: "40%",
    margin: "5px", // till here, mobile view style
    [theme.breakpoints.up("sm")]: {
      width: "50%",
      float: "right",
      height: "40%",
      margin: "5px",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  button: {
    alignSelf: "center",
    color: "inherit",
    border: "1px solid gray",
    borderRadius: "25px",
    [theme.breakpoints.up("md")]: {
      //alignSelf: "center",
      color: "white",
      border: "1px solid gray",
      //borderRadius: "25px",
      //padding:"10px"
      marginLeft: "10px",
      // '&:hover': {
      //           backgroundColor:"blue"
      // },
    },
  },
  mobileMenuButton: {
    borderColor: "gray",
    borderRadius: "5px",
  },
  mainTabButton: {
    border: "none",
    backgroundColor: "transparent",
    borderColor: "white",
    borderRadius: "50px",
    marginLeft: "5px",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&:active": {
      backgroundColor: "transparent !important",
    },
  },
  icon: {
    fontSize: 30,
  },
}));

export default function PrimaryAppBar(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleMobileMenuClose}>
        <HomeNavigation callFrom="mobileView" />
      </MenuItem>
      <MenuItem onClick={handleMobileMenuClose}>
        <NavLink to="/help">
          <ButtonR
            className={classes.mobileMenuButton}
          >
            <HelpIcon className={classes.icon} />
          </ButtonR>
        </NavLink>
      </MenuItem>
      <MenuItem>
        <ButtonR className={classes.mobileMenuButton}>
          <FaSignOutAlt
            onClick={() => Auth.signOut()}
            className={classes.icon}
          />
        </ButtonR>
      </MenuItem>
    </Menu>
  );

  return (
    <div className={classes.grow}>
      <AppBar position="static" style={{ backgroundColor: props.login?"#6c757d":"#E8E8E8" }}>
      { 
        props.login && 
        <Toolbar style={{minHeight:"50px"}} >
          <img src={Logo} alt="GF logo" className={classes.logo} />
          <img src={Logo2} alt="GF logo" className={classes.logo2} />
          <Typography className={classes.title} variant="h6">
            Excess Tools Part List & Accessories Declaration Form
          </Typography>
          <div className={classes.grow} />          
          <div className={classes.sectionDesktop}>
            <HomeNavigation code={props.code} />
            <NavLink to="/help">
              <ButtonR  className={classes.mainTabButton} >
                <HelpIcon className={classes.icon} />
              </ButtonR>
            </NavLink>
            <ButtonR onClick={() => Auth.signOut()} className={classes.mainTabButton} >
              <FaSignOutAlt className={classes.icon} />Logout
            </ButtonR>
          </div>          
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div>          
        </Toolbar>
      }
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
}
